import { useState } from 'react';
import { NOTIFICATION_TYPES } from '../utils/constants';

export const useNotification = () => {
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    color: NOTIFICATION_TYPES.SUCCESS,
  });

  const showNotification = (message, color = NOTIFICATION_TYPES.SUCCESS) => {
    setNotification({
      open: true,
      message,
      color,
    });
  };

  const closeNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  return {
    notification,
    showNotification,
    closeNotification
  };
};